const color_rate = {
    'S': 'bg-gradient-to-r from-[#8c52ff] to-[#ff914d]', 
    'A': 'bg-rose-500', 
    'B': 'bg-amber-500', 
    'C': 'bg-emerald-500', 
    'D': 'bg-sky-500', 
    'E': 'bg-slate-500', 
    'F': 'bg-black'
};

export default color_rate;
